import { createReducer, on } from '@ngrx/store';
import {
  FinishUserFirstPassword,
  InitUserFirstPassword,
  ValidateResetPasswordToken,
  ValidateUserFirstPasswordToken,
} from './invitation.actions';

export interface InvitationState {
  isTokenValid: boolean;
  loading: boolean;
  requestInProgress: boolean;
}

export const initialInvitationState: InvitationState = {
  isTokenValid: false,
  loading: true,
  requestInProgress: false,
};

export const invitationReducer = createReducer(
  initialInvitationState,
  on(InitUserFirstPassword, (state) => {
    return {
      ...state,
      requestInProgress: true,
    };
  }),
  on(FinishUserFirstPassword, (state) => {
    return {
      ...state,
      requestInProgress: false,
    };
  }),
  on(ValidateUserFirstPasswordToken, (state, newState) => {
    return {
      ...state,
      isTokenValid: newState.isTokenValid,
      loading: false,
    };
  }),
  on(ValidateResetPasswordToken, (state, newState) => {
    return {
      ...state,
      isTokenValid: newState.isTokenValid,
      loading: false,
    };
  })
);
